// Display labels for the Usage tab's machine codes, shared by the report (Usage.tsx) and the Spend
// detail list (UsageSpendDetail.tsx). REF-6975: Spend detail's `tool` is an action_code, not an
// object_type — the vocabularies overlap (design_canvas, trend_analysis, brand_dna_analysis, …), so
// it uses this same catalog and falls through to the humanized code for anything not in it.

// BE REF-5515 §6: the breakdown dimension is object_type — a MACHINE value for the tool/object
// category credit was spent on. Map it to a display label here (FE catalog); never hardcode which
// appear. Unknown/empty → "Unknown"; any value missing from the catalog falls back to a humanized
// form of the raw string. (Raw English per this file's i18n deferral — moves to the catalog with
// REF-5298. Vocabulary grows over time — add new object_types as the BE surfaces them.)
export const OBJECT_TYPE_LABELS: Record<string, string> = {
  studio_projects: "Studio",
  studio_product_results: "Studio (per product)",
  design_canvas: "Design Canvas",
  download_4k: "4K Download",
  posts: "Designs",
  search_chat: "Search Chat",
  techpack: "Tech Pack",
  fabric_dna: "Fabric DNA",
  trend_analysis: "Trend Analysis",
  brand_dna_analysis: "Brand DNA",
  model_training: "Model Training",
  unknown: "Unknown",
};

export const objectTypeLabel = (type?: string | null): string => {
  if (!type) return "Unknown";

  return OBJECT_TYPE_LABELS[type] ?? type.replace(/[_-]+/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());
};
